import { render, staticRenderFns } from "./SidebarGroupItem.vue?vue&type=template&id=6ae5b3f2&"
import script from "./SidebarGroupItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SidebarGroupItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports